import React from 'react';
import styles from './Brands.module.scss';
import { BrandTableColumnProps, BrandTableProps } from 'enums/BrandsEnums';
import clsx from 'clsx';
import { ReactComponent as Delete } from 'assets/icons/delete.svg';
import { ReactComponent as Edit } from 'assets/icons/draft.svg';
import stringComparator from 'shared/utils/stringComparator';

interface BrandRecord {
  name: string;
  category: string;
  product: number;
  emission: number;
}

interface GetBrandColumnsProps {
  showEditModal: (record: BrandRecord) => void;
  showDeleteModal: (record: BrandRecord) => void;
}

export const getBrandColumns = ({
  showDeleteModal,
  showEditModal,
}: GetBrandColumnsProps) => {
  return [
    {
      title: BrandTableColumnProps.NAME_TITLE,
      dataIndex: BrandTableColumnProps.NAME_DATA_INDEX,
      defaultSortOrder: BrandTableColumnProps.NAME_DEFAULT_SORT_ORDER,
      width: BrandTableColumnProps.NAME_ICON_WIDTH,
      sorter: (a: BrandRecord, b: BrandRecord) =>
        stringComparator(a.name, b.name),
    },
    {
      title: BrandTableColumnProps.CATEGORIES_TITLE,
      dataIndex: BrandTableColumnProps.CATEGORIES_DATA_INDEX,
      defaultSortOrder: BrandTableColumnProps.CATEGORIES_DEFAULT_SORT_ORDER,
      width: BrandTableColumnProps.CATEGORIES_ICON_WIDTH,
      sorter: (a: BrandRecord, b: BrandRecord) =>
        stringComparator(a.category, b.category),
    },
    {
      title: BrandTableColumnProps.PRODUCTS_TITLE,
      dataIndex: BrandTableColumnProps.PRODUCTS_DATA_INDEX,
      defaultSortOrder: BrandTableColumnProps.CATEGORIES_DEFAULT_SORT_ORDER,
      width: BrandTableColumnProps.PRODUCTS_ICON_WIDTH,
      align: 'left' as const,
      sorter: (a: BrandRecord, b: BrandRecord) => a.product - b.product,
    },
    {
      title: (
        <p>
          Total Emissions (tonnes Co<sub>2</sub>e)
        </p>
      ),
      dataIndex: BrandTableColumnProps.EMISSION_DATA_INDEX,
      defaultSortOrder: BrandTableColumnProps.EMISSION_DEFAULT_SORT_ORDER,
      width: BrandTableColumnProps.EMISSION_ICON_WIDTH,
      align: 'center' as const,
      sorter: (a: BrandRecord, b: BrandRecord) => a.emission - b.emission,
      render: (value: number) => value?.toFixed(4),
    },
    {
      title: BrandTableColumnProps.ACTION_ICON_TITLE,
      dataIndex: BrandTableColumnProps.ACTION_ICON_DATA_INDEX,
      width: BrandTableColumnProps.ACTION_ICON_WIDTH,
      align: 'right' as const,
      render: (_text: string, record: BrandRecord, index: number) => (
        <span className={styles.actionIconContainer}>
          <>
            <div
              className={clsx({
                [styles.rowIcon]: true,
                [styles.editIconContainer]: true,
              })}
              onClick={() => showEditModal(record)}>
              <Edit
                type={BrandTableProps.EDIT_ICON_ALT}
                className={styles.editIcon}
              />
            </div>
            <div
              className={clsx({
                [styles.rowIcon]: true,
                [styles.editIconContainer]: true,
              })}
              onClick={() => showDeleteModal(record)}>
              <Delete
                type={BrandTableProps.DELETE_ICON_ALT}
                className={styles.deleteIcon}
              />
            </div>
          </>
        </span>
      ),
    },
  ];
};
